import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import { Auxilio } from './AuxlioTransporte';
import moment from 'moment';
import { appURL } from '../../../services/auth/jwt/config';
import carteirinhaBackground from '../../../asset/carteirinha_2026.png';

// Create styles
const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        fontSize: '0.5rem',
    },
    section: {
        flexGrow: 1,
    },
    image: {
        width: '100%',
    },
    name: {
        position: 'absolute',
        fontSize: 8,
        left: 110,
        top: 79,
    },
    ensino: {
        position: 'absolute',
        fontSize: 8,
        left: 125,
        top: 117,
    },
    nascimento: {
        position: 'absolute',
        fontSize: 8,
        left: 160,
        top: 105,
    },
    curso: {
        position: 'absolute',
        fontSize: 8,
        left: 60,
        top: 140,
    },
    cpf: {
        position: 'absolute',
        fontSize: 8,
        left: 105,
        top: 92,
    },
    validade: {
        position: 'absolute',
        fontSize: 8,
        left: 178,
        top: 122.7,
    },
    turno: {
        position: 'absolute',
        fontSize: 8,
        left: 214,
        top: 122.7,
    },
    ano: {
        position: 'absolute',
        left: 168,
        top: 148.5,
        fontSize: 8,
        color: '#fff',
        fontWeight: 'bold',
    },
    foto: {
        position: 'absolute',
        left: 12,
        top: 30,
        width: 65,
        height: 75,
        objectFit: 'cover',
    },
});

interface AuxilioCarteiraProps {
    data: Auxilio;
}

// Cria o componente do documento
const AuxilioCarteira = ({ data }: AuxilioCarteiraProps) => {
    const getFotoUrl = () => {
        let url = '';
        if (data.anexos) {
            data.anexos.forEach(anexo => {
                if (anexo.tipo_interno === 'foto') {
                    url = `${appURL}${anexo.link}`;
                }
            });
        }
        return url;
    };

    {/* @ts-ignore */ }
    return <Document>
        {/* @ts-ignore */}
        <Page size="EXECUTIVE" orientation="portrait">
            <View>
                <Image style={styles.image} src={carteirinhaBackground} />
                {/* @ts-ignore */}
                {getFotoUrl() ? <Image style={styles.foto} src={getFotoUrl()} /> : null}
                <Text style={styles.name}>{data.nome?.toUpperCase()}</Text>
                <Text style={styles.ensino}>{data.instituicao}</Text>
                <Text style={styles.nascimento}>{data.nascimento}</Text>
                <Text style={styles.curso}>{data.curso}</Text>
                <Text style={styles.cpf}>{data.cpf}</Text>
                {/* <Text style={styles.validade}>2023</Text>
                <Text style={styles.turno}>{data.turno}</Text>
                <Text style={styles.ano}>{moment().year()}</Text> */}
            </View>
        </Page>
    </Document>
};

export default AuxilioCarteira;
